import { AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { AXIOS_INSTANCE } from "../../api/client";
import { getAuth } from "firebase/auth";

export type TSurveyFormAnswerResponce = {
  status_code: number;
  data: any;
};

export const postImage = async (
  body: any
): Promise<TSurveyFormAnswerResponce> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const request = {
    url: `/images`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" , Authorization: `Bearer ${token}`} as AxiosRequestHeaders,
    data: body,
  };
  return AXIOS_INSTANCE(request as AxiosRequestConfig<any>).then(
    ({ data }) => data
  );
};

export const postCommonMemberIcon = async (
  body: any
): Promise<TSurveyFormAnswerResponce> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const request = {
    url: `/images/common/member-icon`,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" , Authorization: `Bearer ${token}`} as AxiosRequestHeaders,
    data: body,
  };
  return AXIOS_INSTANCE(request as AxiosRequestConfig<any>).then(
    ({ data }) => data
  );
};
